module.exports = __webpack_public_path__ + "static/social-8a45b88866be38cf709a4e79a0a1a7eb.jpg";